import React from 'react';
import style from './ErrorBoundary.module.css';
import { toast } from 'react-toastify';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error('[ErrorBoundary]', error, errorInfo);
		try {
			toast.error(
				this.props.toastMessage || 'Something went wrong. Please try again.',
				{ toastId: 'error-boundary', autoClose: 5000 }
			);
		} catch {
			/* toast container may not be mounted yet at the top-level boundary */
		}
	}

	handleReset = () => {
		this.setState({ hasError: false, error: null });
	};

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) {
				return this.props.fallback;
			}

			if (this.props.compact) {
				return (
					<div className={style.CompactErrorContainer}>
						<div className={style.CompactErrorIcon}>!</div>
						<p className={style.CompactErrorMessage}>Something went wrong on this page.</p>
						<div className={style.CompactActions}>
							<button className={style.CompactRetryButton} onClick={this.handleReset}>
								Try Again
							</button>
							<button className={style.CompactRefreshButton} onClick={() => window.location.reload()}>
								Refresh
							</button>
						</div>
					</div>
				);
			}

			return (
				<div className={style.ErrorContainer}>
					<div className={style.ErrorCard}>
						<div className={style.ErrorIcon}>!</div>
						<h2 className={style.ErrorTitle}>Something went wrong</h2>
						<p className={style.ErrorMessage}>
							An unexpected error occurred. Please try again or refresh the page.
						</p>
						<div className={style.ErrorActions}>
							<button
								className={style.RetryButton}
								onClick={this.handleReset}
							>
								Try Again
							</button>
							<button
								className={style.RefreshButton}
								onClick={() => window.location.reload()}
							>
								Refresh Page
							</button>
						</div>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
